import { defineMessages } from "react-intl";
import { getDay } from "date-fns";

export const MESSAGES = defineMessages({
  monday: {
    id: "efef4ed4-3ddf-4303-bc4a-1e5c1173c9e8",
    defaultMessage: "Monday",
  },
  tuesday: {
    id: "669e1aed-557d-43ca-ba95-85f98bcb28dd",
    defaultMessage: "Tuesday",
  },
  wednesday: {
    id: "27695181-b160-48df-8915-512da6d2b759",
    defaultMessage: "Wednesday",
  },
  thursday: {
    id: "a69f22cf-c608-4853-b5af-f7527704ea78",
    defaultMessage: "Thursday",
  },
  friday: {
    id: "c31dc890-4e60-440c-b920-6c1127e6d621",
    defaultMessage: "Friday",
  },
  saturday: {
    id: "b6a036f9-fd3a-4ddc-89ae-e7f78a1f1c55",
    defaultMessage: "Saturday",
  },
  sunday: {
    id: "290cb4b8-68e2-4aa2-b6fa-299853b63a56",
    defaultMessage: "Sunday",
  },
});

export type Day = keyof typeof MESSAGES;

export const DAYS_OF_WEEK: Readonly<Day[]> = Object.freeze([
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
]);

export function getWeekdayLabel(date: Date) {
  switch (getDay(date)) {
    case 0:
      return MESSAGES.sunday;
    case 1:
      return MESSAGES.monday;
    case 2:
      return MESSAGES.tuesday;
    case 3:
      return MESSAGES.wednesday;
    case 4:
      return MESSAGES.thursday;
    case 5:
      return MESSAGES.friday;
    case 6:
      return MESSAGES.saturday;
    default:
      throw new Error(`Unknown day of week for ${date.toISOString()}`);
  }
}
